export default "__VITE_ASSET__DLHKxTJ9__"